import React from 'react';
import { Box, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/common/components/UI/TourCardV2/TourCardV2.styles';

const TourCardSkeletonV2 = () => (
  <StyledBox position="relative">
    {/* Image Section */}
    <Box>
      <Skeleton variant="rectangular" width="100%" height="300px" />
    </Box>

    {/* Info Section */}
    <Box>
      <Box>
        <Skeleton variant="text" width="60%" height={20} />
        <Skeleton variant="text" width="80%" height={28} style={{ margin: '12px 0' }} />
        <Skeleton variant="text" width="50%" height={18} style={{ marginBottom: '16px' }} />
        <Skeleton variant="text" width="70%" height={18} style={{ marginBottom: '16px' }} />
        <Skeleton variant="text" width="40%" height={20} />
      </Box>
    </Box>
  </StyledBox>
);

export { TourCardSkeletonV2 };
